// Darker tiers make the dark text hard to read. A higher chroma or a lighter tier falls outside sRGB.
export const AVATAR_LIGHTNESSES = [0.88, 0.8] as const;
export const AVATAR_CHROMA = 0.055;

// At these lightnesses and this chroma, these hues read as olive and khaki rather than as a pastel.
const MUDDY_HUES = { from: 95, to: 125 } as const;

// Steps of 20°, because closer hues at this low chroma look the same once they are not side by side.
const HUE_STEP = 20;

export const AVATAR_HUES = Array.from({ length: 360 / HUE_STEP }, (_, i) => i * HUE_STEP).filter(
  hue => hue < MUDDY_HUES.from || hue >= MUDDY_HUES.to,
);

const AVATAR_COLORS = AVATAR_LIGHTNESSES.flatMap(lightness =>
  AVATAR_HUES.map(hue => `oklch(${lightness} ${AVATAR_CHROMA} ${hue})`),
);

/** Gives a stable pastel for an ID, from a palette that keeps at least 4.5:1 with dark text. */
export const avatarColor = (seed: string): string => {
  const hash = seed.split('').reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
  return AVATAR_COLORS[((hash % AVATAR_COLORS.length) + AVATAR_COLORS.length) % AVATAR_COLORS.length];
};
